import { Gender } from './Competition';

export const enum StageShowStandings {
    Yes = 'yes',
    No = 'no'
}

export const enum StageIsCurrent {
    Yes = 'yes',
    No = 'no'
}

export const enum StageHasBrackets {
    Yes = 'yes',
    No = 'no'
}

export interface Stage {
    id: number
    stage_name_id: number
    name: string
    sort: number
    is_current: StageIsCurrent
    has_brackets: StageHasBrackets
    show_standings: StageShowStandings
    gender: Gender
}
